export default __webpack_public_path__ + "static/media/logo.c96cd142.jpg";